import { fetchAdminSession, logoutAdmin } from '../../services/apiClient.js';
import { initHeaderMenu } from './headerMenu.js';
import { getCachedIsAdmin, setCachedIsAdmin } from '../../services/adminUiCache.js';

// Header des pages simples hors SPA (Escales, Notice) : burger, liens
// Dashboard/Déconnecter selon la session admin -- même branchement que
// equalearthMain.js.
export function initSiteHeader() {
  initHeaderMenu({
    headerEl: document.querySelector('header'),
    burgerBtn: document.getElementById('burger-btn'),
    navLinks: document.querySelectorAll('.header-nav .nav-link'),
  });

  const dashboardLink = document.getElementById('dashboard-link');
  const adminLogoutBtn = document.getElementById('adminLogoutBtn');
  function showAdminLinks(isAdmin) {
    if (dashboardLink) dashboardLink.hidden = !isAdmin;
    if (adminLogoutBtn) adminLogoutBtn.hidden = !isAdmin;
  }

  showAdminLinks(getCachedIsAdmin());
  fetchAdminSession()
    .then((data) => {
      const isAdmin = Boolean(data?.isAdmin);
      showAdminLinks(isAdmin);
      setCachedIsAdmin(isAdmin);
    })
    .catch(() => {
      showAdminLinks(false);
      setCachedIsAdmin(false);
    });

  adminLogoutBtn?.addEventListener('click', (e) => {
    e.target.disabled = true;
    logoutAdmin().catch(() => {}).finally(() => { window.location.href = '/'; });
  });
}
